import { NavLink } from "react-router-dom";

export default function AdminSidebar() {
  return (
    <div className="admin-sidebar">
      <div className="sidebar-header">Admin Panel</div>
      <nav className="sidebar-menu">
        <NavLink to="/admin-dashboard" className="sidebar-link">Dashboard</NavLink>
        <NavLink to="/admin-orders" className="sidebar-link">Orders</NavLink>
        <NavLink to="/admin-payments" className="sidebar-link">Payments</NavLink>
        <NavLink to="/admin-products" className="sidebar-link">Products</NavLink>
        <NavLink to="/admin-users" className="sidebar-link">Users</NavLink>
      </nav>
    </div>
  );
}
